<div class="mr-t--md mr-b--md">
    <a class="btn btn-link btn-icon btn-icon--left btn-back"
       *ngIf="!isHome"
       [routerLink]="['/home']">
        {{ 'back' | translate }}
    </a>
    <app-breadcrumb class="hidden"
                    [firstNode]="{label: 'Package Billing', 'url': '/home'}">
    </app-breadcrumb>

    <div class="box">
        <div class="card card--b2c--box pb-1">
            <div class="card--b2c--box__header">
                <div class="card--b2c--box__header--info">
                    <div *ngIf="!isClinicView" class="card--b2c--box__header__title">
                        {{ 'Package Billing' | translate }}
                    </div>
                </div>
                <div class="card--b2c--box__header--info search-txt">
                    <span class="pull-left">
                        {{ 'Current Billing Range' | translate }} : {{ filterParams.startDate | datex:'DD.MM.YYYY' }} - {{ filterParams.endDate | datex:'DD.MM.YYYY' }}
                    </span>

                    <span class="pull-left mr-l--md" *ngIf="isHome">
                        <i class="fal fa-file-csv export-csv" title="{{ 'Export CSV' | translate }}" (click)="exportData()"></i>
                    </span>
                </div>

                <div class="text-xs-right">
                    <span class="card--b2c--box__header__action">
                        <button *ngIf="isHome"
                                type="button" class="btn btn-block pl-3"
                                [routerLink]="['/b2c-patients/package-billing']">
                            {{ 'View All' | translate }}
                            <i class="fal fa-light fa-arrow-right"></i>
                        </button>
                    </span>
                </div>
            </div>
        </div>

        <b2c-admin-filters-search *ngIf="!isHome"
                                  [hasClinic]="true"
                                  [hasDate]="true"
                                  [hasTestData]="true"
                                  [exportable]="true"
                                  (setFilterParams)="setFilterParams($event)"
                                  (exportData)="exportData($event)"
                                  (searchData)="getItems()"></b2c-admin-filters-search>

        <div class="b2c-table--grid billing-total" *ngIf="billing">
            <div class="b2c-table--grid__body billing__body">
                <div class="row">
                    <!--table headers-->
                    <div class="col-xs-12 billing__column">
                        <div class="row">
                            <div class="col-xs-8">
                                <span class="">{{ 'Product' | translate }}</span>
                            </div>
                            <div class="col-xs-4">
                                <span class="">{{ 'Amount' | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--table cells-->
                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div class="col-xs-8">
                                <span class="col col--dynamic-report">
                                    <span>{{ 'Dynamic Report'  | translate }}</span>
                                </span>
                            </div>
                            <div class="col-xs-4">
                                <span class="col col--dynamic-report">
                                    <span>{{ billing['dynamic_report'] }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div class="col-xs-8">
                                <span class="col col--dynamic-report">
                                    <span>{{ 'Appointment'  | translate }}</span>
                                </span>
                            </div>
                            <div class="col-xs-4">
                                <span class="col col--dynamic-report">
                                    <span>{{ billing['appointment'] }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div class="col-xs-8">
                                <span class="col col--dynamic-report">
                                    <span>{{ 'Appointment with discount' | translate  }}</span>
                                </span>
                            </div>
                            <div class="col-xs-4">
                                <span class="col col--dynamic-report">
                                    <span>{{ billing['appointment_discount'] }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div class="col-xs-8">
                                <span class="col col--dynamic-report">
                                    <span>{{ 'Combined product' | translate }}</span>
                                </span>
                            </div>
                            <div class="col-xs-4">
                                <span class="col col--dynamic-report">
                                    <span>{{ billing['combined'] }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="b2c-table--grid billing-details mr-t--md" *ngIf="items.length && !isHome">
            <div class="b2c-table--grid__body">
                <div class="row">
                    <!--table headers-->
                    <div class="col-xs-12 billing__column">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }}"
                                 (click)="sortBilling(column[0]);"
                                 title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span [ngClass]="{'sorted': sortIsActivated && (sortedColumn === column[0]
                                                || (sortedColumn === 'created_at_sort' && column[0] === 'created_at')),
                                                'asc': order === 'asc', 'desc': order === 'desc'}">
                                    {{ column[1] | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--table cells-->
                <div *ngFor="let billing of items
                        | orderBy : orderField: sortedColumn
                        | filterText: searchInfo.keyword:'name,email'
                        | slice : ((currentPage-1)*itemsPerPage):(currentPage*itemsPerPage)"
                     class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }}">
                                <span class="col col--{{column[0]}}">
                                    {{ billing[column[0]] }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

         <!--pagination-->
        <pagination-component *ngIf="!isHome && items" [(page)]="currentPage"
         [total]="(items | filterText: searchInfo.keyword:'name,email').length" [perPage]="itemsPerPage"
         [limit]="maxSize" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginate($event)"
         #pagination></pagination-component>
    </div>
</div>


<!-- DIRECTIVE : EXPORT SYMPTOM MAP FOR PATIENT -->
<div class="hidden-xs-up">
    <form id="frmExport" action="{{authService.baseUrl}}b2c-patients/billings/export" method="POST">
        <textarea id="package-billing" name="package-billing">
        </textarea>
    </form>
</div>

<dialog-component #dialog></dialog-component>
